// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27Xaa","rootNoMargin":"styles_rootNoMargin__1eaHs"};